<template>
  <div class="export">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem to="/host/index/home">首页</BreadcrumbItem>
          <BreadcrumbItem to="/host/index/act/act-home">活动管理</BreadcrumbItem>
          <BreadcrumbItem>导出活动</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">导出活动</div>
      </div>
    </div>

    <div class="export-content">
      <div class="content">
        <p class="title">任务记录</p>
        <div class="btn">
          <Dropdown style="margin-right: 20px;">
            <Button type="primary">
              创建新任务
              <Icon type="ios-arrow-down"></Icon>
            </Button>
            <DropdownMenu slot="list" style="width:200px;">
              <DropdownItem @click.native="createAll">创建导出全部数据任务</DropdownItem>
              <DropdownItem @click.native="createCurrent">创建导出当前展会数据任务</DropdownItem>
            </DropdownMenu>
          </Dropdown>
          <Button :loading="loading" icon="ios-sync" @click="loading=true;init();">刷新任务状态</Button>
        </div>
        <Table :border="false" row-key="id" :columns="columns" :data="list">
          <template slot-scope="{ row, index }" slot="name">{{row.taskName}}</template>
          <template slot-scope="{ row, index }" slot="taskType"> 
            <template v-if="row.taskType === 8">活动导出</template>
          </template>
          <template slot-scope="{ row, index }" slot="taskState">
            <template v-if="row.taskState === 0">等待导出【当前】</template>
            <template v-if="row.taskState === 1">正在导出</template>
            <template v-if="row.taskState === 2">导出成功</template>
            <template v-if="row.taskState === -1">导出失败</template>
          </template>
          <template slot-scope="{ row, index }" slot="submitTime">{{row.submitTime | moment("YYYY-MM-DD")}}</template>
          <template slot-scope="{ row, index }" slot="taskResult">
            <!-- 导出成功 -->
            <template v-if="row.taskState === 2">
              <a :href="row.taskResult" target="view_window">下载地址</a>
            </template>
            <!-- 导出失败 -->
            <template v-else>
              {{row.taskResult || "无"}}
            </template>
          </template>
        </Table>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  name: "host-product",
  data () {
    return {
      columns: [
        {
          title: "任务名称",
          slot: "name",
          key: "name",
          align: "center"
        },
        {
          title: "任务类型",
          key: "taskType",
          slot: "taskType",
          align: "center"
        },
        {
          title: "任务状态",
          key: "taskState",
          slot: "taskState",
          align: "center"
        },
        {
          title: "任务时间",
          key: "submitTime",
          slot: "submitTime",
          align: "center"
        },
        {
          title: "任务结果",
          key: "taskResult",
          slot: "taskResult",
          align: "center"
        },
      ],
      list: [],
      loading: false,
    };
  },
  components: {
  },
  created () {
    this.init();
  },
  computed: {
    ...mapGetters({
    }),
    exhibitionInfo () {
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    }
  },
  methods: { 
    ...mapActions({
      getTask: "hostCommonModule/getTaskByType",
      addTask: "hostCommonModule/addTask",
    }),
    async init () {     
      let list = await this.getTask({ exhibitionId: this.exhibitionInfo.id, taskTypes: [8] });
      this.list = list;
      this.loading = false;
    },
    async createAll () {
      let req = {
        "taskType": 8,
        "taskName": "全部活动导出",
        "exhibitionId": "00000000-0000-0000-0000-000000000000",
      }
      let bool = await this.addTask(req);
      if (bool && bool.successed) {
        this.init();
        this.$Message.success("创建成功！");
      } else {
        this.$Message.success("创建失败，请重新尝试");
      }
    },
    async createCurrent () {
      let req = {
        "taskType": 8,
        "taskName": this.exhibitionInfo.name + "活动导出",
        "exhibitionId": this.exhibitionInfo.id,
      }
      let bool = await this.addTask(req);
      if (bool && bool.successed) {
        this.init();
        this.$Message.success("创建成功！");
      } else {
        this.$Message.success("创建失败，请重新尝试");
      }
    }
  }
};
</script>

<style scoped lang="scss">
.export {
  &-content {
    min-width: 600px;
    padding: 30px 30px 50px 30px;
    .content {
      background-color: #fff;
      padding: 0 30px 30px;
      .title {
        line-height: 50px;
        font-size: 16px;
        border-bottom: 1px solid #e8e8e8;
      }
      .btn {
        margin: 20px 0;
      }
    }
  }
}
.export-content {
  /deep/ .ivu-select-dropdown {
    width: 200px;
  }
}
</style>
